export const mainAxisSideLookup = {
  top: 'start',
  right: 'end',
  bottom: 'end',
  left: 'start'
};